var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerMultipleChoiceOptionsLayout } from './options/AbfragerMultipleChoiceOptionsLayout';
import { AbfragerMultipleChoiceLikeOption } from './options/AbfragerMultipleChoiceLikeOption';
import { AbfragerQuestionAnswerPart } from '../../scenes/showQuestion/AbfragerQuestionAnswerPart';
import { AbfragerQuestionComment } from '../../scenes/showQuestion/AbfragerQuestionComment';
import { CommentType } from '../../../../classes/learnware/LearnwareEnums';
let AbfragerMultipleChoiceAnswerPart = class AbfragerMultipleChoiceAnswerPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        return (React.createElement(AbfragerQuestionAnswerPart, { question: question },
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                    display: 'flex',
                    alignItems: 'stretch',
                    flexDirection: 'column',
                    paddingLeft: 14,
                    paddingTop: 15,
                    paddingRight: 14,
                    paddingBottom: 5,
                } },
                React.createElement(AbfragerMultipleChoiceOptionsLayout, { question: question }, question.shuffledOptions.map((option, indexInLayout) => (React.createElement(AbfragerMultipleChoiceLikeOption, { option: option, key: option.shuffledOptionIndex, indexInLayout: indexInLayout }))))),
            React.createElement(AbfragerQuestionComment, { question: question, commentType: CommentType.Comment }),
            React.createElement(AbfragerQuestionComment, { question: question, commentType: CommentType.CommentCorrect }),
            React.createElement(AbfragerQuestionComment, { question: question, commentType: CommentType.CommentWrong })));
    }
    componentDidMount() {
        // console.timeEnd('READY');
    }
};
AbfragerMultipleChoiceAnswerPart = __decorate([
    observer
], AbfragerMultipleChoiceAnswerPart);
export { AbfragerMultipleChoiceAnswerPart };
